import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7538d0c0")

_pushScopeId("data-v-7538d0c0")
const _hoisted_1 = { class: "autocomplete" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dynamicOptions, (option) => {
      return (_openBlock(), _createBlock(_component_el_tag, {
        key: option,
        closable: "",
        type: "success",
        "disable-transitions": false,
        onClose: ($event: any) => (_ctx.handleClose(option))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(option.name), 1)
        ]),
        _: 2
      }, 1032, ["onClose"]))
    }), 128)),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_autocomplete, {
        class: "margin-top-5 margin-bottom-5",
        size: "small",
        "value-key": "name",
        modelValue: _ctx.inputValue,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputValue = $event)),
        "fetch-suggestions": _ctx.querySearch,
        placeholder: "搜索标签或输入后回车",
        onSelect: _ctx.handleSelect,
        onChange: _ctx.handleInputConfirm
      }, null, 8, ["modelValue", "fetch-suggestions", "onSelect", "onChange"])
    ])
  ], 64))
})